/* The First Four · discovery set wizard
   Screens managed client side: intro, quiz (six questions), gift, composing,
   results, amend, review, done. Logic ported from the First Four v3 prototype:
   state restore, scoring, reason lines, sliders, drawers. Adds the OJtool
   proxy tracking, Klaviyo onsite events, dataLayer pushes and the real cart.
   Vanilla, no dependencies. No em dashes. British English. */
(function () {
  'use strict';

  // Display-time translation (Arabic dictionary from snippets/ff-ar-i18n.liquid); identity elsewhere.
  // Answer labels and other internal keys stay English: only text being shown passes through T().
  function T(s) { return window.FF_T ? window.FF_T(s) : s; }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; } catch (e) { return ''; }
  }
  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function clamp01(v) { return Math.max(0, Math.min(1, v)); }

  function ensureKlaviyo(publicKey) {
    if (!publicKey || window.klaviyo || window._learnq) return;
    try {
      window._learnq = window._learnq || [];
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://static.klaviyo.com/onsite/js/' + encodeURIComponent(publicKey) + '/klaviyo.js';
      document.head.appendChild(s);
    } catch (e) {}
  }
  function kTrack(name, props) {
    try {
      var kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') kl.push(['track', name, props || {}]);
    } catch (e) {}
  }
  function kIdentify(props) {
    try {
      var kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') kl.push(['identify', props || {}]);
    } catch (e) {}
  }

  function makeSessionId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (e) {}
    return 'ff-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function init(root) {
    if (root.__ffInit) return;
    root.__ffInit = true;

    var cfgEl = root.querySelector('[data-ff-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.pool || !cfg.pool.length) return;

    ensureKlaviyo(cfg.klaviyo && cfg.klaviyo.publicKey);

    var priceStr = (cfg.price && cfg.price.label) || '£25';
    var expiryWords = { 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight', 9: 'nine', 10: 'ten', 11: 'eleven', 12: 'twelve' };
    var expiryWord = expiryWords[cfg.creditExpiryMonths || 6] || String(cfg.creditExpiryMonths || 6);
    var proxyBase = String(cfg.proxyBase || '/apps/fs/first-four').replace(/\/$/, '');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- static data (ported from the prototype) ---------- */
    var famOrder = ['citrus', 'floral', 'woody', 'amberesque', 'gourmand', 'oudh'];
    var famLabels = { citrus: 'Citrus', floral: 'Floral', woody: 'Woody', amberesque: 'Amberesque', gourmand: 'Gourmand', oudh: 'Oudh' };
    var worldLabels = { citrus: 'citrus groves and sea air', floral: 'white flowers and warm skin', woody: 'woods, moss and cut grass', amberesque: 'amber, spice and resins', gourmand: 'vanilla, praline and sweetness', oudh: 'oudh, smoke and enriched' };
    var worldShort = { citrus: 'citrus groves', floral: 'white flowers', woody: 'woods and moss', amberesque: 'amber and resins', gourmand: 'vanilla and praline', oudh: 'oudh and smoke' };
    var worldToFam = { 'Citrus groves and sea air': 'citrus', 'White flowers and warm skin': 'floral', 'Woods, moss and cut grass': 'woody', 'Amber, spice and resins': 'amberesque', 'Vanilla, praline and sweetness': 'gourmand', 'Oudh, smoke and enriched': 'oudh' };
    var timeIcons = {
      Morning: 'M3 17.5h18 M8 17.5a4 4 0 0 1 8 0 M12 10V5.5 M9.8 7.7 12 5.5l2.2 2.2 M5 12.4 3.6 11 M19 12.4l1.4-1.4',
      Day: 'M12 16.2a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4z M12 3v2.4 M12 18.6V21 M3 12h2.4 M18.6 12H21 M5.6 5.6l1.7 1.7 M16.7 16.7l1.7 1.7 M18.4 5.6l-1.7 1.7 M7.3 16.7l-1.7 1.7',
      Evening: 'M3 17.5h18 M8 17.5a4 4 0 0 1 8 0 M12 5.5V10 M14.2 7.8 12 10 9.8 7.8 M5 12.4 3.6 11 M19 12.4l1.4-1.4',
      Night: 'M20.2 14.1A8.2 8.2 0 1 1 9.9 3.8a6.6 6.6 0 0 0 10.3 10.3z'
    };
    var timeBgs = { Morning: '#F6E9D8', Day: '#FDF7EA', Evening: '#E5CBAD', Night: '#3E2B2E' };
    var A = cfg.assets || {};
    var questions = [
      { id: 'who', kind: 'cards', title: 'Who are the four for?', answers: [
        { label: 'Myself', hint: 'For yours truly.' },
        { label: 'A gift', hint: 'Would you like to send a message?' }
      ] },
      { id: 'experience', title: 'How do you choose perfume?', cols: 'repeat(2, minmax(0, 1fr))', ratio: '3 / 2', answers: [
        { label: 'One signature scent', hint: 'The same bottle, always.', img: A.expSignature },
        { label: 'A small collection', hint: 'A shelf of my favourite perfumes and wear according to my mood.', img: A.expCollection },
        { label: 'Occasionally', hint: 'Kept for special days.', img: A.expOccasional },
        { label: 'I am new to all this', hint: 'We are here to help you.', bg: '#E04E39' }
      ] },
      { id: 'worlds', title: 'Which worlds draw you in?', sub: 'Choose up to two', multi: true, cols: 'repeat(auto-fit, minmax(min(100%, 210px), 1fr))', ratio: '4 / 3', answers: [
        { label: 'Citrus groves and sea air', img: (A.worlds || [])[0] },
        { label: 'White flowers and warm skin', img: (A.worlds || [])[1] },
        { label: 'Woods, moss and cut grass', img: (A.worlds || [])[2] },
        { label: 'Amber, spice and resins', img: (A.worlds || [])[3] },
        { label: 'Vanilla, praline and sweetness', img: (A.worlds || [])[4] },
        { label: 'Oudh, smoke and enriched', img: (A.worlds || [])[5] }
      ] },
      { id: 'presence', kind: 'presence', title: 'How do you like your fragrance to perform?', sub: 'Set the volume', answers: [
        { label: 'On the skin', hint: 'Only for whoever leans in.' },
        { label: 'An arm’s length', hint: 'Noticed by those beside you.' },
        { label: 'Across the room', hint: 'It arrives before you do.' }
      ] },
      { id: 'occasion', kind: 'times', title: 'When will they be worn?', sub: 'From first light to last hour', answers: [
        { label: 'Morning', hint: 'First light, fresh skin.' },
        { label: 'Day', hint: 'Desks, errands, open air.' },
        { label: 'Evening', hint: 'Dinner, dusk, candlelight.' },
        { label: 'Night', hint: 'The closing hours of the day.' }
      ] },
      { id: 'adventure', title: 'How adventurous should we be?', sub: 'The mix of vials in your set', answers: [
        { label: 'Keep it classic', known: 4, hint: 'All four labelled, the house’s best loved.', img: (A.adventure || [])[0] },
        { label: 'Classic, with one surprise', known: 3, hint: 'Three best loved and you pick one for me.', img: (A.adventure || [])[1] },
        { label: 'Surprise me', known: 2, hint: 'Two best loved and two surprises.', img: (A.adventure || [])[2] }
      ] }
    ];

    var pool = cfg.pool;
    var poolById = {};
    pool.forEach(function (f) { poolById[f.id] = f; });
    function frag(id) { return poolById[id]; }
    function availPool() { return pool.filter(function (f) { return f.available && f.variantId; }); }

    var KEY = 'oj-first-four-wizard';
    var countWords = ['None', 'One', 'Two', 'Three', 'Four'];
    var stageNames = { intro: 'The offer', quiz: 'Your taste', gift: 'The gift', composing: 'Composing', results: 'Your four', amend: 'Amend your four', review: 'Review', done: 'Confirmed' };

    /* ---------- state ---------- */
    var state = {
      stage: 'intro',
      qIndex: 0,
      answers: {},
      selections: [],
      reasons: {},
      path: null,
      bagged: false,
      email: '',
      emailSent: false,
      q: '',
      drawerId: null,
      swapSlot: null,
      cameFrom: 'results',
      activeFam: null,
      doneKind: 'set',
      sessionId: makeSessionId(),
      sessionSent: false,
      timePos: null,
      timeDragging: false
    };
    var cartAdding = false;
    var composeTimer = null;

    function needsFour(stage) { return stage === 'results' || stage === 'review'; }

    function restore() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return;
        var s = JSON.parse(raw);
        if (!s || !s.ts || Date.now() - s.ts >= 30 * 24 * 3600 * 1000) return;
        var sel = (s.selections || []).filter(function (id) { var f = frag(id); return f && f.available && f.variantId; });
        var rs = {};
        Object.keys(s.reasons || {}).forEach(function (k) { if (frag(k)) rs[k] = s.reasons[k]; });
        /* Composing resumes at results; a finished (done) visit starts fresh. */
        var want = s.stage === 'composing' ? 'results' : s.stage && s.stage !== 'done' ? s.stage : 'intro';
        if (want === 'gift' && !(cfg.gift && cfg.gift.enabled && cfg.gift.variantId)) want = 'quiz';
        var stage = needsFour(want) && sel.length !== 4 ? 'amend' : want;
        state.answers = s.answers || {};
        state.qIndex = s.qIndex || 0;
        state.selections = sel;
        state.reasons = rs;
        state.path = sel.length ? (s.path || null) : null;
        state.stage = stage;
        state.cameFrom = 'intro';
        if (s.sessionId) state.sessionId = s.sessionId;
        state.sessionSent = !!s.sessionSent;
      } catch (e) {}
    }
    function save() {
      try {
        localStorage.setItem(KEY, JSON.stringify({
          answers: state.answers,
          qIndex: state.qIndex,
          selections: state.selections,
          reasons: state.reasons,
          path: state.path,
          stage: state.stage,
          sessionId: state.sessionId,
          sessionSent: state.sessionSent,
          ts: Date.now()
        }));
      } catch (e) {}
    }

    /* ---------- tracking ---------- */
    function dl(event, data) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: event, quiz: 'first_four' }, data || {}));
      } catch (e) {}
    }
    function api(path, data) {
      try {
        var url = proxyBase + path;
        var payload = JSON.stringify(Object.assign({ sessionId: state.sessionId }, data || {}));
        if (navigator.sendBeacon) {
          var ok = navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' }));
          if (ok) return;
        }
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    function apiFetch(path, data) {
      try {
        return fetch(proxyBase + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.assign({ sessionId: state.sessionId }, data || {})),
          keepalive: true
        });
      } catch (e) { return Promise.reject(e); }
    }
    function isGift() { return state.answers.who === 'A gift'; }
    /* Reason lines keyed by sample SKU, the shape the app's /complete accepts. */
    function reasonsBySku(ids) {
      var out = {};
      (ids || []).forEach(function (id) {
        var f = frag(id);
        if (f && f.sku && state.reasons && state.reasons[id]) out[f.sku] = state.reasons[id];
      });
      return out;
    }
    /* Cart attributes the app reads on orders/paid and fulfilment: session, source and gift flag. */
    function cartAttributes(kind) {
      return {
        _first_four_session: state.sessionId,
        _first_four_source: state.path === 'quiz' ? 'quiz' : 'self',
        _first_four_gift: kind === 'card' ? 'card' : (isGift() ? 'yes' : 'no')
      };
    }
    function ensureSession(source) {
      if (state.sessionSent) return;
      state.sessionSent = true;
      api('/session', {
        clientId: state.sessionId,
        landingUrl: window.location.href,
        referrer: document.referrer || '',
        utmSource: param('utm_source'),
        utmMedium: param('utm_medium'),
        utmCampaign: param('utm_campaign'),
        utmTerm: param('utm_term'),
        utmContent: param('utm_content'),
        market: (cfg.market && cfg.market.handle) || '',
        source: source,
        isGift: isGift()
      });
      save();
    }
    function commitAnswer(qid, val, qi) {
      var isArr = Object.prototype.toString.call(val) === '[object Array]';
      ensureSession('quiz');
      dl('quiz_answer', { question: qid, answer: isArr ? val.join(', ') : val });
      kTrack('First Four Question Answered', { question: qid, answer: isArr ? val.join(', ') : val });
      var payload = { questionId: qid, answerValue: isArr ? val.join(', ') : val, qIndex: qi };
      if (isArr) payload.answerIds = val; else payload.answerId = val;
      api('/answer', payload);
    }
    function skus(ids) {
      return ids.map(function (id) { var f = frag(id); return f ? f.sku : id; });
    }

    /* ---------- element lookups ---------- */
    function $(sel) { return root.querySelector(sel); }
    function $all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    var screens = {};
    $all('[data-ff-screen]').forEach(function (el) { screens[el.getAttribute('data-ff-screen')] = el; });

    var backBtn = $('[data-ff-back]');
    var stepBtn = $('[data-ff-step]');
    var progressEl = $('[data-ff-progress]');
    var quizEl = screens.quiz;
    var quizBg = $('[data-ff-quiz-bg]');
    var qEyebrow = $('[data-ff-q-eyebrow]');
    var qTitle = $('[data-ff-q-title]');
    var qSub = $('[data-ff-q-sub]');
    var qBody = $('[data-ff-q-body]');
    var qContinue = $('[data-ff-q-continue]');
    var resultsEyebrow = $('[data-ff-results-eyebrow]');
    var resultsHeading = $('[data-ff-results-heading]');
    var resultsIntro = $('[data-ff-results-intro]');
    var resultsList = $('[data-ff-results-list]');
    var amendEyebrow = $('[data-ff-amend-eyebrow]');
    var amendHeading = $('[data-ff-amend-heading]');
    var slotsEl = $('[data-ff-slots]');
    var searchInput = $('[data-ff-search]');
    var famNavEl = $('[data-ff-famnav]');
    var amendList = $('[data-ff-amend-list]');
    var noMatchesEl = $('[data-ff-no-matches]');
    var amendCount = $('[data-ff-amend-count]');
    var reviewRows = $('[data-ff-review-rows]');
    var bagBtn = $('[data-ff-add-bag]');
    var bagLabel = $('[data-ff-add-bag-label]');
    var bagError = $('[data-ff-bag-error]');
    var doneHeading = $('[data-ff-done-heading]');
    var doneBody = $('[data-ff-done-body]');
    var checkoutBtn = $('[data-ff-checkout]');
    var emailBlock = $('[data-ff-email-block]');
    var emailForm = $('[data-ff-email-form]');
    var emailInput = $('[data-ff-email-input]');
    var emailSend = $('[data-ff-email-send]');
    var emailError = $('[data-ff-email-error]');
    var emailSentEl = $('[data-ff-email-sent]');
    var barEl = $('[data-ff-bar]');
    var barNote = $('[data-ff-bar-note]');
    var barBtn = $('[data-ff-bar-primary]');
    var barLabel = $('[data-ff-bar-label]');
    var offerScrim = $('[data-ff-offer-scrim]');
    var offerDrawer = $('[data-ff-offer-drawer]');
    var fragScrim = $('[data-ff-frag-scrim]');
    var fragDrawer = $('[data-ff-frag-drawer]');
    var fragName = $('[data-ff-frag-name]');
    var fragFam = $('[data-ff-frag-fam]');
    var fragImg = $('[data-ff-frag-img]');
    var fragDots = $('[data-ff-frag-dots]');
    var fragOcc = $('[data-ff-frag-occ]');
    var fragNotes = $('[data-ff-frag-notes]');
    var fragDesc = $('[data-ff-frag-desc]');
    var fragAdd = $('[data-ff-frag-add]');
    var fragAddLabel = $('[data-ff-frag-add-label]');
    var liveEl = $('[data-ff-live]');
    var giftEmail = $('[data-ff-gift-email]');
    var giftEmailError = $('[data-ff-gift-email-error]');
    var giftName = $('[data-ff-gift-name]');
    var giftMessage = $('[data-ff-gift-message]');
    var giftCount = $('[data-ff-gift-count]');
    var giftDate = $('[data-ff-gift-date]');
    var giftError = $('[data-ff-gift-error]');
    var giftAddBtn = $('[data-ff-gift-add]');

    /* ---------- small builders ---------- */
    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = T(text);
      return node;
    }
    function dotsEl(n) {
      var wrap = el('span', 'ff-dots');
      for (var i = 1; i <= 5; i++) {
        var d = el('span');
        if (i <= n) d.className = 'is-on';
        wrap.appendChild(d);
      }
      return wrap;
    }
    function occLabel(o) { return o === 'day' ? 'Day' : o === 'evening' ? 'Evening' : 'Day and evening'; }
    function thumbEl(f, mod) {
      var wrap = el('span', 'ff-thumb' + (mod ? ' ff-thumb--' + mod : ''));
      if (f.image) {
        var img = el('span', 'ff-thumb__img');
        img.setAttribute('role', 'img');
        img.setAttribute('aria-label', f.name);
        img.style.backgroundImage = 'url(' + f.image + ')';
        wrap.appendChild(img);
      } else {
        var ph = el('span', 'ff-thumb__ph');
        var box = el('span', 'ff-thumb__ph-box');
        box.appendChild(el('span', 'ff-thumb__ph-ring'));
        box.appendChild(el('span', 'ff-thumb__ph-initial', f.name.charAt(0)));
        ph.appendChild(box);
        wrap.appendChild(ph);
      }
      return wrap;
    }
    function setPrimary(btn, on) {
      btn.disabled = !on;
      btn.classList.toggle('is-off', !on);
    }
    function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function toTop() { window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' }); }
    function announce(text) { if (liveEl) liveEl.textContent = T(text); }

    /* ---------- scoring (ported verbatim, over the available pool) ---------- */
    function chosenFams() {
      return (state.answers.worlds || []).map(function (w) { return worldToFam[w]; }).filter(Boolean);
    }
    function score(f) {
      var a = state.answers, fams = chosenFams();
      var s = f.families.filter(function (x) { return fams.indexOf(x) >= 0; }).length * 3;
      var target = a.presence === 'On the skin' ? 2 : a.presence === 'Across the room' ? 5 : 3;
      s += Math.max(0, (4 - Math.abs(f.intensity - target)) / 4 * 2);
      var occ = a.occasion === 'Morning' || a.occasion === 'Day' ? 'day' : a.occasion === 'Evening' || a.occasion === 'Night' ? 'evening' : 'both';
      if (f.occasion === 'both' || occ === 'both' || f.occasion === occ) s += 1;
      if (a.experience === 'I am new to all this' && f.character === 'classic') s += 0.6;
      if (a.experience === 'Occasionally' && f.character === 'classic') s += 0.3;
      if (a.experience === 'A small collection' && f.character !== 'classic') s += 0.3;
      return s;
    }
    function computeMatches() {
      var fams = chosenFams(), mix = state.answers.adventure;
      var candidates = availPool();
      var P = candidates.length;
      var scored = candidates.map(function (f) {
        return { f: f, s: score(f) + (mix === 'Keep it classic' ? (P - f.rank) / P * 1.5 : 0) };
      });
      scored.sort(function (a, b) { return b.s - a.s || a.f.rank - b.f.rank; });
      var noOverlap = function (x) { return !x.f.families.some(function (m) { return fams.indexOf(m) >= 0; }); };
      var picks, reasons = {};
      if (mix === 'Classic, with one surprise') {
        picks = scored.slice(0, 3);
        var surprise = scored.find(function (x) { return picks.indexOf(x) < 0 && noOverlap(x) && x.f.character === 'adventurous'; }) ||
          scored.find(function (x) { return picks.indexOf(x) < 0 && noOverlap(x); }) || scored[3];
        picks = picks.concat([surprise]);
        reasons[surprise.f.id] = 'The one surprise you asked for, from a world to explore.';
      } else if (mix === 'Surprise me') {
        picks = scored.slice(0, 2);
        var wild = scored.filter(function (x) { return picks.indexOf(x) < 0 && noOverlap(x); }).slice(0, 2);
        picks = picks.concat(wild.length === 2 ? wild : scored.slice(2, 4 - wild.length).concat(wild));
        wild.forEach(function (x) { reasons[x.f.id] = 'A wildcard from outside your chosen worlds, since you asked us to surprise you.'; });
      } else {
        picks = scored.slice(0, 4);
      }
      picks = picks.slice(0, 4);
      var seen = {};
      picks.forEach(function (x) {
        if (reasons[x.f.id]) return;
        var ov = x.f.families.find(function (m) { return fams.indexOf(m) >= 0; });
        if (!ov) { reasons[x.f.id] = 'A gentle signature of the house, close to your answers.'; return; }
        seen[ov] = (seen[ov] || 0) + 1;
        var label = worldLabels[ov], short = worldShort[ov] || label;
        reasons[x.f.id] = seen[ov] === 1 ? 'Because you chose ' + label + '.' : seen[ov] === 2 ? 'Also from the ' + short + ' you chose, at a different hour.' : 'A third turn through the ' + short + ' you chose.';
      });
      return { ids: picks.map(function (x) { return x.f.id; }), reasons: reasons };
    }
    function reasonFor(f) {
      if (state.reasons[f.id]) return state.reasons[f.id];
      return 'For those drawn to ' + (worldLabels[f.families[0]] || 'the house') + '. ' + f.profile;
    }

    /* ---------- navigation ---------- */
    function go(stage, extra) {
      Object.assign(state, extra || {});
      if (needsFour(stage) && state.selections.length !== 4) {
        stage = 'amend';
        if (!state.cameFrom) state.cameFrom = 'intro';
      }
      state.stage = stage;
      save();
      render();
      toTop();
      var n = state.selections.length;
      var suffix = (stage === 'results' || stage === 'amend') ? '. ' + countWords[n] + ' of four chosen.' : '';
      announce((stageNames[stage] || stage) + suffix);
    }
    function back() {
      var st = state;
      if (st.stage === 'quiz') {
        if (st.qIndex > 0) go('quiz', { qIndex: st.qIndex - 1 });
        else go('intro');
        return;
      }
      if (st.stage === 'gift') go('quiz', { qIndex: 0 });
      else if (st.stage === 'results') {
        if (st.path === 'quiz') go('quiz', { qIndex: questions.length - 1 });
        else go('amend', { cameFrom: 'intro', swapSlot: null });
      }
      else if (st.stage === 'amend') go(st.cameFrom === 'intro' ? 'intro' : 'results', { swapSlot: null });
      else if (st.stage === 'review') go('results');
      else if (st.stage === 'done') go(st.doneKind === 'giftcard' ? 'gift' : 'review');
    }
    function jumpTo(id) {
      setTimeout(function () {
        var c = amendList, g = document.getElementById(id);
        if (c && g) c.scrollTop += g.getBoundingClientRect().top - c.getBoundingClientRect().top;
      }, 40);
    }

    /* ---------- quiz interactions ---------- */
    function pick(qid, label, multi) {
      var q = questions[state.qIndex];
      if (multi) {
        var cur = (state.answers[qid] || []).slice();
        var i = cur.indexOf(label);
        if (i >= 0) cur.splice(i, 1); else if (cur.length < 2) cur.push(label);
        state.answers[qid] = cur;
        save();
        renderQuiz();
        return;
      }
      if (q && (q.kind === 'times' || q.kind === 'presence') && q.id === qid) {
        state.answers[qid] = label;
        save();
        renderQuiz();
        return;
      }
      state.answers[qid] = label;
      save();
      commitAnswer(qid, label, state.qIndex);
      if (qid === 'who' && label === 'A gift' && cfg.gift && cfg.gift.enabled && cfg.gift.variantId) {
        api('/event', { type: 'gift_view' });
        go('gift');
        return;
      }
      if (state.qIndex >= questions.length - 1) finishQuiz();
      else go('quiz', { qIndex: state.qIndex + 1 });
    }
    function quizContinue() {
      var q = questions[state.qIndex];
      if (!q) return;
      if (q.multi && (state.answers[q.id] || []).length === 0) return;
      if ((q.kind === 'times' || q.kind === 'presence') && !state.answers[q.id]) return;
      commitAnswer(q.id, state.answers[q.id], state.qIndex);
      if (state.qIndex >= questions.length - 1) finishQuiz();
      else go('quiz', { qIndex: state.qIndex + 1 });
    }
    function finishQuiz() {
      var m = computeMatches();
      dl('quiz_complete', { families: chosenFams() });
      // OJTool records the OpenAI Ads conversion after /complete validates
      // the four results. Keeping one server-side source also preserves the
      // richer identity payload and deterministic event-id deduplication.
      apiFetch('/complete', { fragrances: skus(m.ids), source: 'quiz', isGift: isGift(), email: state.email || null, reasons: reasonsBySku(m.ids) }).catch(function () {});
      var reveal = function () {
        dl('results_view');
        api('/event', { type: 'results_viewed' });
        kTrack('First Four Results Viewed', { fragrances: skus(state.selections) });
        go('results');
      };
      if (reduced()) {
        Object.assign(state, { selections: m.ids, reasons: m.reasons, path: 'quiz', bagged: false });
        save();
        reveal();
        return;
      }
      Object.assign(state, { stage: 'composing', selections: m.ids, reasons: m.reasons, path: 'quiz', bagged: false });
      save();
      render();
      toTop();
      announce('Composing your four');
      if (composeTimer) clearTimeout(composeTimer);
      composeTimer = setTimeout(reveal, 1500);
    }

    /* ---------- set edits ---------- */
    function changeSet(sel, cb) {
      state.selections = sel;
      state.bagged = false;
      save();
      dl('set_edit');
      api('/event', { type: 'set_edit' });
      kTrack('First Four Set Edited', { fragrances: skus(sel) });
      render();
      if (cb) cb();
    }
    function addFrag(id) {
      var f = frag(id);
      if (!f || !f.available || !f.variantId) return;
      var sel = state.selections.slice();
      if (sel.indexOf(id) >= 0) { closeFrag(); return; }
      if (state.swapSlot != null && sel[state.swapSlot]) {
        sel[state.swapSlot] = id;
        state.swapSlot = null;
        closeFrag();
        changeSet(sel, function () {
          if (sel.filter(Boolean).length === 4) go('results');
        });
        return;
      }
      if (sel.length >= 4) {
        closeFrag();
        state.swapSlot = 0;
        save();
        render();
        return;
      }
      sel.push(id);
      state.path = state.path || 'self';
      closeFrag();
      var cameFrom = state.cameFrom;
      changeSet(sel, function () {
        if (sel.length === 4 && cameFrom === 'intro') go('results');
      });
    }

    /* ---------- cart ---------- */
    function routeUrl(name, fallback) {
      var r = window.routes || {};
      return (r[name] || fallback);
    }
    function cartGetUrl() {
      var r = window.routes || {};
      return r.cart_url ? r.cart_url + '.js' : '/cart.js';
    }
    function postJson(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
    }
    function removeExistingSetLines() {
      return fetch(cartGetUrl()).then(function (res) { return res.json(); }).then(function (cart) {
        var stale = (cart.items || []).filter(function (item) {
          return item.properties && item.properties._first_four;
        });
        return stale.reduce(function (p, item) {
          return p.then(function () {
            return postJson(routeUrl('cart_change_url', '/cart/change') + '.js', { id: item.key, quantity: 0 });
          });
        }, Promise.resolve());
      });
    }
    function showBagError(msg) {
      if (bagError) {
        bagError.textContent = T(msg);
        bagError.hidden = false;
      }
      // The add now also fires from the results bar, where the review screen's
      // error element is not visible — surface the message in the bar note.
      if (state.stage === 'results' && barNote) {
        barNote.textContent = T(msg);
      }
    }
    function addSetToBag() {
      if (state.selections.length !== 4 || cartAdding || state.bagged) return;
      var frs = state.selections.map(frag);
      var missing = frs.some(function (f) { return !f || !f.available || !f.variantId; });
      if (missing) {
        showBagError('One of your four has just sold out. Choose a replacement and try again.');
        go('amend', { cameFrom: 'results', swapSlot: null });
        return;
      }
      cartAdding = true;
      if (bagError) bagError.hidden = true;
      renderReview();
      var items = frs.map(function (f) {
        return {
          id: f.variantId,
          quantity: 1,
          properties: { _first_four: 'yes', _first_four_session: state.sessionId }
        };
      });
      removeExistingSetLines().then(function () {
        return postJson(routeUrl('cart_add_url', '/cart/add') + '.js', { items: items });
      }).then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (j) {
            var msg = (j && (j.description || j.message)) || 'Something went wrong adding the set. Please try again.';
            cartAdding = false;
            showBagError(msg);
            renderReview();
            if (/sold out|unavailable|not available|out of stock/i.test(String(msg))) {
              go('amend', { cameFrom: 'results', swapSlot: null });
            }
            throw new Error('ff-add-failed');
          });
        }
        return postJson(routeUrl('cart_update_url', '/cart/update') + '.js', { attributes: cartAttributes() }).catch(function () {});
      }).then(function () {
        cartAdding = false;
        state.bagged = true;
        state.doneKind = 'set';
        dl('add_to_bag', { fragrances: skus(state.selections) });
        dl('checkout_click', {});
        // Beacons survive the navigation; the fetch-based call would not.
        api('/event', { type: 'add_to_bag' });
        api('/event', { type: 'checkout_click' });
        api('/complete', { fragrances: skus(state.selections), source: state.path === 'quiz' ? 'quiz' : 'self', isGift: isGift(), email: state.email || null, reasons: reasonsBySku(state.selections) });
        kTrack('First Four Added To Bag', { fragrances: skus(state.selections), value: priceStr });
        save();
        window.location.href = '/checkout';
      }).catch(function (err) {
        cartAdding = false;
        if (!err || err.message !== 'ff-add-failed') {
          showBagError('Something went wrong adding the set. Please try again.');
          renderReview();
        }
      });
    }
    function isoDate(d) {
      var m = d.getMonth() + 1, day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }
    function addGiftToBag() {
      if (cartAdding || !(cfg.gift && cfg.gift.enabled && cfg.gift.variantId)) return;
      var email = (giftEmail && giftEmail.value || '').trim();
      if (!emailValid(email)) {
        if (giftEmailError) giftEmailError.hidden = false;
        if (giftEmail) giftEmail.focus();
        return;
      }
      if (giftEmailError) giftEmailError.hidden = true;
      if (giftError) giftError.hidden = true;
      var name = (giftName && giftName.value || '').trim().slice(0, 255);
      var message = (giftMessage && giftMessage.value || '').trim().slice(0, 200);
      var sendOn = (giftDate && giftDate.value || '').trim();
      if (sendOn) {
        var today = new Date(); today.setHours(0, 0, 0, 0);
        var max = new Date(today.getTime() + 90 * 24 * 3600 * 1000);
        var chosen = new Date(sendOn + 'T00:00:00');
        if (isNaN(chosen.getTime()) || chosen < today || chosen > max) sendOn = '';
      }
      /* Property names verified against snippets/gift-card-recipient-form.liquid:
         __shopify_send_gift_card_to_recipient, Recipient email, Recipient name,
         Message, Send on, __shopify_offset (getTimezoneOffset().toString()). */
      var props = {
        '__shopify_send_gift_card_to_recipient': 'true',
        'Recipient email': email,
        '__shopify_offset': new Date().getTimezoneOffset().toString(),
        '_first_four_gift': 'yes',
        '_first_four_session': state.sessionId
      };
      if (name) props['Recipient name'] = name;
      if (message) props['Message'] = message;
      if (sendOn) props['Send on'] = sendOn;
      cartAdding = true;
      setPrimary(giftAddBtn, false);
      postJson(routeUrl('cart_add_url', '/cart/add') + '.js', {
        items: [{ id: cfg.gift.variantId, quantity: 1, properties: props }]
      }).then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (j) {
            throw new Error((j && (j.description || j.message)) || 'add-failed');
          });
        }
        return postJson(routeUrl('cart_update_url', '/cart/update') + '.js', { attributes: cartAttributes('card') }).catch(function () {});
      }).then(function () {
        cartAdding = false;
        setPrimary(giftAddBtn, true);
        state.doneKind = 'giftcard';
        dl('gift_add');
        api('/event', { type: 'gift_add' });
        kTrack('First Four Gift Added', { value: (cfg.gift && cfg.gift.priceLabel) || priceStr });
        go('done');
      }).catch(function () {
        cartAdding = false;
        setPrimary(giftAddBtn, true);
        if (giftError) {
          giftError.textContent = T('Something went wrong adding the gift. Please try again.');
          giftError.hidden = false;
        }
      });
    }

    /* ---------- render: chrome ---------- */
    function render() {
      Object.keys(screens).forEach(function (k) { screens[k].hidden = k !== state.stage; });
      renderChrome();
      if (state.stage === 'quiz') renderQuiz();
      if (state.stage === 'gift') renderGift();
      if (state.stage === 'results') renderResults();
      if (state.stage === 'amend') renderAmend();
      if (state.stage === 'review') renderReview();
      if (state.stage === 'done') renderDone();
      renderBar();
    }
    function renderChrome() {
      var stage = state.stage;
      if (backBtn) backBtn.hidden = stage === 'intro';
      if (stepBtn) {
        stepBtn.textContent = T((stageNames[stage] || stage) + (stage === 'quiz' ? ' · ' + (state.qIndex + 1) + ' of 6' : ''));
      }
      if (progressEl) {
        var stepOf = stage === 'intro' ? 0 : stage === 'quiz' ? 1 + state.qIndex : stage === 'gift' ? 1 : stage === 'review' ? 8 : stage === 'done' ? 9 : 7;
        progressEl.style.width = Math.min(100, Math.round(Math.max(1, stepOf) / 8 * 100)) + '%';
      }
    }
    function renderBar() {
      var stage = state.stage;
      var show = stage === 'results' || stage === 'amend';
      barEl.hidden = !show;
      if (!show) return;
      var n = state.selections.length;
      var swapFrag = state.swapSlot != null ? frag(state.selections[state.swapSlot]) : null;
      var amendReady = n === 4;
      if (stage === 'results') {
        barLabel.textContent = T('Add to bag · ' + priceStr);
        barNote.textContent = T(countWords[n] + ' of four chosen');
        setPrimary(barBtn, n === 4);
        barBtn.onclick = function () { addSetToBag(); };
      } else {
        barLabel.textContent = T(amendReady ? 'Back to my four' : countWords[n] + ' of four chosen');
        barNote.textContent = T(swapFrag ? 'Replacing ' + swapFrag.name : amendReady ? 'Your four is complete. Choose a fragrance to swap it in.' : 'Choose ' + (4 - n) + ' more');
        setPrimary(barBtn, amendReady);
        barBtn.onclick = function () { if (amendReady) go('results'); };
      }
    }

    /* ---------- render: quiz ---------- */
    var railEl = null, handleEl = null, ringEls = [], stopBtns = [], tickEls = [], trackEl = null;
    function sliderOpts(q) { return q.answers || []; }
    function renderQuiz() {
      var q = questions[state.qIndex];
      if (!q) return;
      qEyebrow.textContent = T('Question ' + ['one', 'two', 'three', 'four', 'five', 'six'][state.qIndex] + ' of six');
      qTitle.textContent = T(q.title);
      if (q.sub) { qSub.textContent = T(q.sub); qSub.hidden = false; } else { qSub.hidden = true; }
      var isTimes = q.kind === 'times';
      var isPresence = q.kind === 'presence';
      var isSlider = isTimes || isPresence;
      var hadFocusOnRail = railEl && document.activeElement === railEl;
      qBody.innerHTML = '';
      railEl = handleEl = trackEl = null;
      ringEls = []; stopBtns = []; tickEls = [];
      if (q.kind === 'cards') buildCards(q);
      else if (isSlider) buildSlider(q);
      else buildPhotos(q);
      var multiSel = state.answers[q.id] || (q.multi ? [] : null);
      var show = !!q.multi || isSlider;
      qContinue.hidden = !show;
      var enabled = q.multi ? (multiSel || []).length > 0 : isSlider ? !!state.answers[q.id] : false;
      setPrimary(qContinue, enabled);
      updateSliderVisuals();
      if (hadFocusOnRail && railEl) railEl.focus();
    }
    function buildCards(q) {
      var grid = el('div', 'ff-cards');
      grid.setAttribute('role', 'radiogroup');
      grid.setAttribute('aria-label', T(q.title));
      q.answers.forEach(function (o) {
        var sel = state.answers[q.id] === o.label;
        var btn = el('button', 'ff-card' + (sel ? ' is-selected' : ''));
        btn.type = 'button';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
        btn.appendChild(el('span', 'ff-card__label', o.label));
        if (o.hint) btn.appendChild(el('span', 'ff-card__hint', o.hint));
        btn.addEventListener('click', function () { pick(q.id, o.label, false); });
        grid.appendChild(btn);
      });
      qBody.appendChild(grid);
    }
    function buildPhotos(q) {
      var grid = el('div', 'ff-photos');
      grid.setAttribute('role', q.multi ? 'group' : 'radiogroup');
      grid.setAttribute('aria-label', T(q.title));
      grid.setAttribute('data-qid', q.id);
      grid.style.gridTemplateColumns = q.cols || 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))';
      var multiSel = state.answers[q.id] || [];
      q.answers.forEach(function (o) {
        var sel = q.multi ? multiSel.indexOf(o.label) >= 0 : state.answers[q.id] === o.label;
        var btn = el('button', 'ff-photo' + (sel ? ' is-selected' : '') + (o.bg ? ' ff-photo--flat' : ''));
        btn.type = 'button';
        btn.setAttribute('role', q.multi ? 'checkbox' : 'radio');
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
        btn.style.aspectRatio = q.ratio || '4 / 5';
        if (o.bg) btn.style.background = o.bg;
        var img = el('span', 'ff-photo__img');
        img.setAttribute('aria-hidden', 'true');
        if (o.img) img.style.backgroundImage = 'url(' + o.img + ')';
        btn.appendChild(img);
        var scrim = el('span', 'ff-photo__scrim');
        scrim.setAttribute('aria-hidden', 'true');
        btn.appendChild(scrim);
        var frame = el('span', 'ff-photo__frame');
        frame.setAttribute('aria-hidden', 'true');
        btn.appendChild(frame);
        var text = el('span', 'ff-photo__text');
        text.appendChild(el('span', 'ff-photo__label', o.label));
        if (o.hint) text.appendChild(el('span', 'ff-photo__hint', o.hint));
        btn.appendChild(text);
        btn.addEventListener('click', function () { pick(q.id, o.label, !!q.multi); });
        grid.appendChild(btn);
      });
      qBody.appendChild(grid);
    }
    function buildSlider(q) {
      var isTimes = q.kind === 'times';
      var opts = sliderOpts(q);
      var n = opts.length;
      var wrap = el('div', 'ff-slider' + (isTimes ? ' ff-slider--times' : ''));
      if (!isTimes) {
        var rings = el('div', 'ff-rings');
        rings.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < 5; i++) {
          var ring = el('span', 'ff-rings__ring');
          ring.style.width = (56 + i * 52) + 'px';
          ring.style.height = (56 + i * 52) + 'px';
          rings.appendChild(ring);
          ringEls.push(ring);
        }
        rings.appendChild(el('span', 'ff-rings__core'));
        wrap.appendChild(rings);
      }
      var rail = el('div', 'ff-rail');
      rail.setAttribute('role', 'slider');
      rail.setAttribute('tabindex', '0');
      rail.setAttribute('aria-label', T(q.title));
      rail.setAttribute('aria-valuemin', '0');
      rail.setAttribute('aria-valuemax', String(n - 1));
      var sInset = 100 / (2 * n);
      var track = el('span', 'ff-rail__track');
      track.setAttribute('aria-hidden', 'true');
      track.style.left = sInset + '%';
      track.style.right = sInset + '%';
      rail.appendChild(track);
      trackEl = track;
      var sSpan = 100 - 2 * sInset, sTop = Math.max(1, n - 1);
      opts.forEach(function (o, i) {
        var tick = el('span', 'ff-rail__tick');
        tick.setAttribute('aria-hidden', 'true');
        tick.style.left = (sInset + i * (sSpan / sTop)) + '%';
        rail.appendChild(tick);
        tickEls.push(tick);
      });
      var handle = el('span', 'ff-rail__handle');
      handle.setAttribute('aria-hidden', 'true');
      rail.appendChild(handle);
      handleEl = handle;
      rail.addEventListener('pointerdown', timeDown);
      rail.addEventListener('keydown', timeKey);
      wrap.appendChild(rail);
      railEl = rail;
      var stops = el('div', 'ff-stops');
      stops.setAttribute('data-stops', String(n));
      opts.forEach(function (o) {
        var sel = state.answers[q.id] === o.label;
        var btn = el('button', 'ff-stop' + (sel ? ' is-selected' : ''));
        btn.type = 'button';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
        if (isTimes && timeIcons[o.label]) {
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('width', '28');
          svg.setAttribute('height', '28');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
          svg.setAttribute('stroke-width', '1.1');
          svg.setAttribute('stroke-linecap', 'square');
          var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', timeIcons[o.label]);
          svg.appendChild(path);
          btn.appendChild(svg);
        }
        btn.appendChild(el('span', 'ff-stop__label', o.label));
        if (o.hint) btn.appendChild(el('span', 'ff-stop__hint', o.hint));
        btn.addEventListener('click', function () { pick(q.id, o.label, false); });
        stops.appendChild(btn);
        stopBtns.push(btn);
      });
      wrap.appendChild(stops);
      qBody.appendChild(wrap);
    }
    function updateSliderVisuals() {
      var q = questions[state.qIndex];
      if (!q) return;
      var isTimes = q.kind === 'times';
      var isPresence = q.kind === 'presence';
      var isSlider = isTimes || isPresence;
      quizEl.classList.toggle('is-dragging', !!state.timeDragging);
      if (!isSlider) {
        quizBg.style.background = 'transparent';
        quizEl.classList.remove('is-night');
        return;
      }
      var opts = sliderOpts(q);
      var labels = opts.map(function (o) { return o.label; });
      var n = opts.length;
      var sTop = Math.max(1, n - 1);
      var sInset = 100 / (2 * n), sSpan = 100 - 2 * sInset;
      var selIdx = labels.indexOf(state.answers[q.id]);
      var liveIdx = state.timeDragging && state.timePos != null ? Math.round(state.timePos * sTop) : selIdx;
      var liveLabel = liveIdx >= 0 ? labels[liveIdx] : null;
      var nightNow = isTimes && liveLabel === 'Night';
      var sliderV = state.timeDragging && state.timePos != null ? state.timePos : selIdx >= 0 ? selIdx / sTop : 0;
      var posPct = sInset + sliderV * sSpan;
      if (handleEl) {
        handleEl.style.left = posPct + '%';
        handleEl.classList.toggle('is-set', selIdx >= 0 || !!state.timeDragging);
      }
      if (railEl) {
        railEl.setAttribute('aria-valuenow', String(selIdx < 0 ? 0 : selIdx));
        railEl.setAttribute('aria-valuetext', T(state.answers[q.id] || 'No time chosen yet'));
      }
      ringEls.forEach(function (ring, i) {
        var reach = selIdx >= 0 || state.timeDragging ? 1 + sliderV * 4 : 0;
        ring.style.opacity = String(clamp01(reach - i) * (0.9 - i * 0.16));
      });
      quizBg.style.background = isTimes
        ? (timeBgs[liveLabel] || 'transparent')
        : 'rgba(224, 78, 57, ' + (sliderV * 0.07).toFixed(3) + ')';
      quizEl.classList.toggle('is-night', nightNow);
    }
    function timeT(e) {
      var q = questions[state.qIndex];
      var n = q ? sliderOpts(q).length : 4;
      var inset = 1 / (2 * n);
      var r = railEl.getBoundingClientRect();
      return clamp01((e.clientX - r.left - r.width * inset) / (r.width * (1 - 2 * inset)));
    }
    function timeDown(e) {
      if (!railEl) return;
      e.preventDefault();
      var move = function (ev) {
        state.timePos = timeT(ev);
        state.timeDragging = true;
        updateSliderVisuals();
      };
      var up = function (ev) {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        var q = questions[state.qIndex];
        if (!q) return;
        var opts = sliderOpts(q);
        var n = opts.length;
        var idx = Math.round(timeT(ev) * (n - 1));
        state.timeDragging = false;
        state.timePos = idx / (n - 1);
        pick(q.id, opts[idx].label, false);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      move(e);
    }
    function timeKey(e) {
      var q = questions[state.qIndex];
      if (!q || (q.kind !== 'times' && q.kind !== 'presence')) return;
      var labels = sliderOpts(q).map(function (o) { return o.label; });
      var top = labels.length - 1;
      var cur = labels.indexOf(state.answers[q.id]);
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = Math.min(top, cur < 0 ? 0 : cur + 1);
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = Math.max(0, cur < 0 ? 0 : cur - 1);
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = top;
      if (next == null) return;
      e.preventDefault();
      state.timePos = next / top;
      state.timeDragging = false;
      pick(q.id, labels[next], false);
    }

    /* ---------- render: gift ---------- */
    function renderGift() {
      if (giftDate) {
        var today = new Date();
        giftDate.min = isoDate(today);
        giftDate.max = isoDate(new Date(today.getTime() + 90 * 24 * 3600 * 1000));
      }
      if (giftCount && giftMessage) giftCount.textContent = String(giftMessage.value.length);
    }

    /* ---------- render: results ---------- */
    function renderResults() {
      var gift = isGift();
      resultsEyebrow.textContent = T(state.path === 'quiz' ? 'Matched from your answers' : 'Chosen by you');
      resultsHeading.textContent = T(state.path === 'quiz'
        ? (gift ? 'The four we think they’ll enjoy' : 'The four we believe you’ll enjoy')
        : 'Your personal four of the best');
      resultsIntro.textContent = T(state.path === 'quiz'
        ? 'These are the four we suggest from your answers, each with its reason. You can swap any of them for others in our range before you check out.'
        : 'These are the four in your set. You can swap any of them for others in our range before you check out.');
      resultsList.innerHTML = '';
      state.selections.map(function (id, i) { return { id: id, i: i, f: frag(id) }; })
        .filter(function (x) { return x.f; })
        .forEach(function (x) {
          var f = x.f;
          var row = el('div', 'ff-result');
          row.setAttribute('data-m-row-center', '');
          row.appendChild(thumbEl(f));
          var info = el('span', 'ff-result__info');
          info.appendChild(el('span', 'ff-result__name', f.name));
          info.appendChild(el('span', 'ff-result__fam', f.style));
          info.appendChild(el('span', 'ff-result__notes', f.keyNotes));
          var meta = el('span', 'ff-result__meta');
          meta.appendChild(dotsEl(f.intensity));
          meta.appendChild(el('span', 'ff-occ', occLabel(f.occasion)));
          info.appendChild(meta);
          info.appendChild(el('span', 'ff-result__reason', reasonFor(f)));
          row.appendChild(info);
          var pyr = el('span', 'ff-result__pyr');
          [['Head', f.pyramid && f.pyramid.head], ['Heart', f.pyramid && f.pyramid.heart], ['Soul', f.pyramid && f.pyramid.soul]]
            .filter(function (p) { return p[1]; })
            .forEach(function (p) {
              var line = el('span', 'ff-pyr-row');
              line.appendChild(el('span', 'ff-pyr-row__label', p[0]));
              line.appendChild(el('span', 'ff-pyr-row__text', p[1]));
              pyr.appendChild(line);
            });
          row.appendChild(pyr);
          var swap = el('button', 'ff-result__swap', 'Swap');
          swap.type = 'button';
          swap.addEventListener('click', function () {
            api('/event', { type: 'swap' });
            go('amend', { swapSlot: x.i, cameFrom: 'results', activeFam: f.families[0], q: '' });
            if (searchInput) searchInput.value = '';
          });
          row.appendChild(swap);
          resultsList.appendChild(row);
        });
    }

    /* ---------- render: amend ---------- */
    function renderAmend() {
      var n = state.selections.length;
      var swapFrag = state.swapSlot != null ? frag(state.selections[state.swapSlot]) : null;
      amendEyebrow.textContent = T(swapFrag ? 'Replacing ' + swapFrag.name : 'The full collection');
      amendHeading.textContent = T(swapFrag ? 'Choose its replacement' : n < 4 ? 'Choose your four' : 'Amend your four');
      /* Slots */
      slotsEl.innerHTML = '';
      [0, 1, 2, 3].forEach(function (i) {
        var id = state.selections[i];
        var f = id && frag(id);
        var active = state.swapSlot === i;
        var btn = el('button', 'ff-slot' + (f ? ' is-filled' : '') + (active ? ' is-active' : ''));
        btn.type = 'button';
        btn.appendChild(el('span', 'ff-slot__num', '0' + (i + 1)));
        var thumb = el('span', 'ff-slot__thumb');
        var timg = el('span', 'ff-slot__thumb-img');
        if (f && f.image) timg.style.backgroundImage = 'url(' + f.image + ')';
        if (f) {
          timg.setAttribute('role', 'img');
          timg.setAttribute('aria-label', f.name);
        }
        thumb.appendChild(timg);
        btn.appendChild(thumb);
        btn.appendChild(el('span', 'ff-slot__label', f ? f.name : 'Empty'));
        btn.appendChild(el('span', 'ff-slot__mark', f ? (active ? '•' : '×') : ''));
        btn.addEventListener('click', function () {
          if (!f) return;
          state.swapSlot = state.swapSlot === i ? null : i;
          save();
          render();
        });
        slotsEl.appendChild(btn);
      });
      /* Family navigation */
      famNavEl.innerHTML = '';
      famOrder.forEach(function (k) {
        var btn = el('button', 'ff-famnav__btn' + (state.activeFam === k ? ' is-active' : ''), famLabels[k]);
        btn.type = 'button';
        btn.addEventListener('click', function () {
          state.activeFam = k;
          render();
          jumpTo('afam-' + k);
        });
        famNavEl.appendChild(btn);
      });
      /* Grouped list */
      var qy = (state.q || '').toLowerCase();
      var filtered = pool.filter(function (f) { return !qy || f.name.toLowerCase().indexOf(qy) >= 0; });
      amendList.innerHTML = '';
      var swapping = state.swapSlot != null;
      famOrder.forEach(function (k) {
        var rows = filtered.filter(function (f) { return f.families[0] === k; });
        if (!rows.length) return;
        var group = el('div', 'ff-amend__group');
        group.id = 'afam-' + k;
        group.appendChild(el('h3', 'ff-amend__group-title', famLabels[k]));
        rows.forEach(function (f) {
          group.appendChild(buildAmendRow(f, n, swapping));
        });
        amendList.appendChild(group);
      });
      noMatchesEl.hidden = filtered.length !== 0;
      amendCount.textContent = T(filtered.length === pool.length
        ? 'All ' + pool.length + ' fragrances, scroll the list'
        : filtered.length + ' of ' + pool.length + ' fragrances');
    }
    function buildAmendRow(f, n, swapping) {
      var inSet = state.selections.indexOf(f.id) >= 0;
      var unavailable = !f.available || !f.variantId;
      var row = el('div', 'ff-row');
      var open = el('button', 'ff-row__open');
      open.type = 'button';
      open.appendChild(thumbEl(f, '62'));
      var text = el('span', 'ff-row__text');
      text.appendChild(el('span', 'ff-row__name', f.name));
      text.appendChild(el('span', 'ff-row__fam', f.style));
      text.appendChild(el('span', 'ff-row__profile', f.profile));
      text.appendChild(el('span', 'ff-row__notes', f.notesLine));
      open.appendChild(text);
      open.addEventListener('click', function () { openFrag(f.id); });
      row.appendChild(open);
      var meta = el('span', 'ff-row__meta');
      meta.appendChild(dotsEl(f.intensity));
      meta.appendChild(el('span', 'ff-occ', occLabel(f.occasion)));
      row.appendChild(meta);
      var add = el('button', 'ff-row__add');
      add.type = 'button';
      var label = inSet ? 'In your four' : unavailable ? 'Sold out' : swapping ? 'Swap in' : n >= 4 ? 'Pick a slot' : 'Add';
      add.textContent = T(label);
      if (inSet || unavailable || (n >= 4 && !swapping)) add.classList.add('is-muted');
      if (unavailable) add.disabled = true;
      add.addEventListener('click', function () { addFrag(f.id); });
      row.appendChild(add);
      return row;
    }

    /* ---------- render: review ---------- */
    function renderReview() {
      reviewRows.innerHTML = '';
      state.selections.map(frag).filter(Boolean).forEach(function (f) {
        var row = el('div', 'ff-review-row');
        row.appendChild(thumbEl(f, '52'));
        var text = el('span', 'ff-review-row__text');
        text.appendChild(el('span', 'ff-review-row__name', f.name));
        text.appendChild(el('span', 'ff-review-row__fam', f.style + ' · 2.5ml'));
        row.appendChild(text);
        reviewRows.appendChild(row);
      });
      var n = state.selections.length;
      var label = state.bagged ? 'In your bag' : n === 4 ? 'Add to bag · ' + priceStr : countWords[n] + ' of four chosen';
      bagLabel.textContent = T(label);
      setPrimary(bagBtn, n === 4 && !state.bagged && !cartAdding);
    }

    /* ---------- render: done ---------- */
    function renderDone() {
      if (state.doneKind === 'giftcard') {
        doneHeading.textContent = T('The gift is in the bag');
        doneBody.textContent = T('A ' + ((cfg.gift && cfg.gift.priceLabel) || priceStr) + ' gift card, ready to send with your message. They will answer the questions themselves and choose their own four.');
        emailBlock.hidden = true;
      } else {
        doneHeading.textContent = T('Your four are in the bag');
        var line = isGift()
          ? 'A set of four, hand-decanted in London and on its way to be given.'
          : 'Four vials, hand-decanted in London, on their way to you.';
        doneBody.textContent = T(line + ' The day the set leaves us, we will email you a ' + priceStr + ' code towards a full bottle.');
        emailBlock.hidden = false;
        emailForm.hidden = state.emailSent;
        emailSentEl.hidden = !state.emailSent;
      }
    }
    function sendResultsEmail() {
      var email = (emailInput && emailInput.value || '').trim();
      if (!emailValid(email)) {
        emailError.hidden = false;
        return;
      }
      emailError.hidden = true;
      emailSend.disabled = true;
      apiFetch('/email', {
        email: email,
        fragrances: skus(state.selections),
        isGift: isGift()
      }).then(function (res) {
        emailSend.disabled = false;
        if (res && res.ok) {
          state.email = email;
          state.emailSent = true;
          dl('lead', { email_domain: email.split('@')[1] || '' });
          kTrack('First Four Email Requested', { fragrances: skus(state.selections) });
          kIdentify({ $email: email });
          renderDone();
          announce('Sent. Your four are in your inbox.');
        } else {
          emailError.hidden = false;
        }
      }).catch(function () {
        emailSend.disabled = false;
        emailError.hidden = false;
      });
    }

    /* ---------- drawers ---------- */
    var lastFocus = null;
    function trapTab(e, dialog) {
      if (e.key !== 'Tab') return;
      var focusables = Array.prototype.slice.call(dialog.querySelectorAll('button, [href], input, textarea, [tabindex]:not([tabindex="-1"])'))
        .filter(function (n) { return !n.disabled && n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function openOffer() {
      lastFocus = document.activeElement;
      offerScrim.hidden = false;
      offerDrawer.hidden = false;
      var close = offerDrawer.querySelector('.ff-drawer__close');
      if (close) close.focus();
    }
    function closeOffer() {
      offerScrim.hidden = true;
      offerDrawer.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function openFrag(id) {
      var f = frag(id);
      if (!f) return;
      state.drawerId = id;
      fragName.textContent = f.name;
      fragFam.textContent = f.style + ' · ' + f.profile;
      fragDrawer.setAttribute('aria-label', f.name);
      fragImg.setAttribute('aria-label', f.name);
      fragImg.style.backgroundImage = f.image ? 'url(' + f.image + ')' : 'none';
      fragDots.innerHTML = '';
      fragDots.appendChild(dotsEl(f.intensity));
      fragOcc.textContent = T(occLabel(f.occasion));
      fragNotes.textContent = T('Headline notes: ' + f.notesLine);
      fragDesc.textContent = f.desc;
      var n = state.selections.length;
      var swapFrag = state.swapSlot != null ? frag(state.selections[state.swapSlot]) : null;
      var unavailable = !f.available || !f.variantId;
      var label = state.selections.indexOf(id) >= 0 ? 'Already in your four'
        : unavailable ? 'Sold out'
        : swapFrag ? 'Swap in for ' + swapFrag.name
        : n >= 4 ? 'Pick a slot to replace'
        : 'Add to my four';
      fragAddLabel.textContent = T(label);
      setPrimary(fragAdd, !unavailable);
      lastFocus = document.activeElement;
      fragScrim.hidden = false;
      fragDrawer.hidden = false;
      var close = fragDrawer.querySelector('.ff-drawer__close');
      if (close) close.focus();
    }
    function closeFrag() {
      if (fragDrawer.hidden) { state.drawerId = null; return; }
      state.drawerId = null;
      fragScrim.hidden = true;
      fragDrawer.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* ---------- top-level actions ---------- */
    function startQuiz() {
      ensureSession('quiz');
      dl('quiz_start');
      kTrack('First Four Started', { price: priceStr });
      go('quiz', { qIndex: 0 });
    }
    function skipToAmend() {
      ensureSession('self');
      go('amend', { path: 'self', cameFrom: 'intro', swapSlot: null });
    }
    function retakeQuiz() {
      go('quiz', { qIndex: 0, answers: {}, selections: [], reasons: {}, path: null, bagged: false, cameFrom: 'intro', swapSlot: null });
    }
    function restart() {
      api('/event', { type: 'restart' });
      go('intro', { selections: [], reasons: {}, answers: {}, qIndex: 0, path: null, bagged: false, swapSlot: null, emailSent: false, email: '', cameFrom: 'intro', activeFam: null, q: '', doneKind: 'set' });
      if (searchInput) searchInput.value = '';
    }
    function proceedToCheckout() {
      dl('checkout_click');
      api('/event', { type: 'checkout_click' });
      window.location.href = (cfg.urls && cfg.urls.checkout) || '/checkout';
    }

    /* ---------- wire events ---------- */
    if (backBtn) backBtn.addEventListener('click', back);
    if (stepBtn) stepBtn.addEventListener('click', openOffer);
    $('[data-ff-start]').addEventListener('click', startQuiz);
    $('[data-ff-self]').addEventListener('click', skipToAmend);
    qContinue.addEventListener('click', quizContinue);
    $('[data-ff-go-amend]').addEventListener('click', function () {
      go('amend', { cameFrom: 'results', swapSlot: null, activeFam: null, q: '' });
      if (searchInput) searchInput.value = '';
    });
    $('[data-ff-retake]').addEventListener('click', retakeQuiz);
    searchInput.addEventListener('input', function () {
      state.q = searchInput.value;
      renderAmend();
    });
    bagBtn.addEventListener('click', addSetToBag);
    checkoutBtn.addEventListener('click', proceedToCheckout);
    emailSend.addEventListener('click', sendResultsEmail);
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); sendResultsEmail(); }
    });
    $('[data-ff-restart]').addEventListener('click', restart);
    $('[data-ff-offer-close]').addEventListener('click', closeOffer);
    offerScrim.addEventListener('click', closeOffer);
    $('[data-ff-frag-close]').addEventListener('click', closeFrag);
    fragScrim.addEventListener('click', closeFrag);
    fragAdd.addEventListener('click', function () {
      if (state.drawerId) addFrag(state.drawerId);
    });
    if (giftAddBtn) giftAddBtn.addEventListener('click', addGiftToBag);
    if (giftMessage) giftMessage.addEventListener('input', function () {
      if (giftCount) giftCount.textContent = String(giftMessage.value.length);
    });
    if (giftEmail) giftEmail.addEventListener('input', function () {
      if (giftEmailError && giftEmail.value.trim()) giftEmailError.hidden = true;
    });
    $('[data-ff-gift-self]').addEventListener('click', function () {
      go('quiz', { qIndex: 1 });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!fragDrawer.hidden) { closeFrag(); return; }
        if (!offerDrawer.hidden) { closeOffer(); return; }
      }
      if (!fragDrawer.hidden) trapTab(e, fragDrawer);
      else if (!offerDrawer.hidden) trapTab(e, offerDrawer);
    });

    /* ---------- boot ---------- */
    restore();
    if (searchInput) searchInput.value = state.q || '';
    render();
  }

  ready(function () {
    var root = document.querySelector('[data-ff]');
    if (root) init(root);
  });
})();
